import { render, staticRenderFns } from "./TotalRoom.vue?vue&type=template&id=566e9cb4&"
import script from "./TotalRoom.vue?vue&type=script&lang=js&"
export * from "./TotalRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports